import { useState } from "react";
import FeedbackIcon from "../../assets/icons/feedback.svg?react";
import { FeedbackModal } from "./FeedbackModal";
import { getUser } from "../../services/utils";
import { useLocation } from 'react-router-dom';




export function FeedbackButton() {
  const user = getUser();
  const location = useLocation();
  const providerChat = location.pathname === '/provider/chat'
  const clientChat = location.pathname === '/family/dashboard'
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  if (!user) return null

  let classes = ''

  if (providerChat) {
    classes = 'right-4 top-4 hidden lg:block'
  } else if (clientChat) {
    classes = 'hidden lg:block lg:left-4 lg:bottom-4'
  } else {
    classes = 'right-4 bottom-4'
  }


  return (<>
    <div
      className={`fixed ${classes} cursor-pointer  bg-white z-[100000] text-white p-4 m-1 rounded-full shadow-lg hover:bg-secondary transition-colors ${showFeedbackModal ? '!bg-primary' : ''}`}
      onClick={() => setShowFeedbackModal((showFeedbackModal) => !showFeedbackModal)}
    >
      <FeedbackIcon className={`h-5 w-5  ${showFeedbackModal ? '[&_path]:fill-white [&_path]:stroke-white' : ''}`} />
    </div >
    {showFeedbackModal && <FeedbackModal onClose={() => setShowFeedbackModal(false)} />}
  </>)
}
